import React, { Component } from "react";

class OrderInnerWrapper extends Component {
  render() {
    const { children, containerRef, ...props } = this.props;

    return (
      <div ref={containerRef} {...props}>
        {children}
      </div>
    );
  }
}

export default OrderInnerWrapper;



// WEBPACK FOOTER //
// ./src/pages/Orders/InnerWrapper.js